// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-homepage-banner-js": () => import("../src/pages/homepageBanner.js" /* webpackChunkName: "component---src-pages-homepage-banner-js" */),
  "component---src-pages-homepage-slider-js": () => import("../src/pages/homepageSlider.js" /* webpackChunkName: "component---src-pages-homepage-slider-js" */),
  "component---src-pages-index-js": () => import("../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

